import { useState } from "react";
import logo from "../assets/techtcl.svg";
import close from "../assets/close.svg";
import hamburger from "../assets/hamburger.svg";
import { NavLink, Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FiFacebook } from "react-icons/fi";
import { FaThreads, FaXTwitter, FaRedditAlien } from "react-icons/fa6";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";

/* Service Portfolio page section links */
const SERVICE_PORTFOLIO_PATHS = [
  "/services/shopify-development",
  "/services/wordpress-development",
  "/services/mobile-app-development",
  "/services/custom-software",
  "/services/data-analytics",
  "/services/uiux-design",
];

/* Shopify has unique sections (grader, portfolio etc.) */
const SHOPIFY_NAV_ITEMS = [
  { label: "Audit", id: "grader", type: "scroll" },
  { label: "Portfolio", id: "portfolio", type: "scroll" },
  { label: "Work", id: "work", type: "scroll" },
  { label: "Services", id: "services", type: "scroll" },
  { label: "Reviews", id: "reviews", type: "scroll" },
  { label: "Blog", id: "blog", type: "hash" },
  { label: "Contact", id: "contact", type: "scroll" },
];

/* Other services use standard template sections */
const SERVICE_NAV_ITEMS = [
  { label: "Work", id: "work", type: "scroll" },
  { label: "Process", id: "process", type: "scroll" },
  { label: "Services", id: "services", type: "scroll" },
  { label: "Reviews", id: "reviews", type: "scroll" },
  { label: "Blog", id: "blog", type: "hash" },
  { label: "Contact", id: "contact", type: "scroll" },
];

export default function Nav() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const isShopifyPage = location.pathname === "/services/shopify-development";
  const isServicePage = SERVICE_PORTFOLIO_PATHS.includes(location.pathname);
  const navItems = isShopifyPage ? SHOPIFY_NAV_ITEMS : SERVICE_NAV_ITEMS;

  const scrollToSection = (item) => {
    setDrawerOpen(false);
    if (item.type === "hash") {
      window.location.hash = "#/" + item.id;
      window.scrollTo(0, 0);
    } else {
      // If currently in blog view (hash is #/blog...), clear hash first to return to main page
      const currentHash = window.location.hash;
      if (currentHash.startsWith("#/blog") || currentHash.startsWith("#/admin")) {
        window.location.hash = "";
        // Wait for page to re-render, then scroll
        setTimeout(() => {
          const el = document.getElementById(item.id);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else {
        const el = document.getElementById(item.id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header className="header" id="header">
      {/* Mobile Header */}
      <div className="nav-container nav_container_mobile">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>

        <nav>
          {/* Hamburger Button */}
          <div className="hamburger">
            {!drawerOpen ? (
              <img
                className="burger"
                src={hamburger}
                alt="hamburger"
                onClick={() => setDrawerOpen(true)}
              />
            ) : (
              <img
                className="close"
                src={close}
                alt="close"
                onClick={() => setDrawerOpen(false)}
              />
            )}
          </div>

          {/* Drawer Menu */}
          <div className={`menu_drawer ${drawerOpen ? "open" : ""}`}>
            <ul className={`nav-menu${isServicePage ? " nav-menu--shopify" : ""}`}>
              <li>
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={() => setDrawerOpen(false)}
                >
                  Home
                </NavLink>
              </li>
              {isServicePage ? (
                <>
                  {navItems.map((item) => (
                    <li key={item.id}>
                      <span
                        className="shopify-nav-link"
                        onClick={() => scrollToSection(item)}
                        style={{ cursor: "pointer" }}
                      >
                        {item.label}
                      </span>
                    </li>
                  ))}
                </>
              ) : (
                <>
                  <li>
                    <NavLink
                      to="/about"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setDrawerOpen(false)}
                    >
                      About
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/services"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Services
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/case-story"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Case Story
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/blogs"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Blog
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/contact"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Contact
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
            <Link
              to="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3njgQ2VnTvu-t0xwpcSzawzvgugS12-dWpKNc2b1UGsTVTKCZ2PbqWkFaizbXoBXQV4filGUBM?gv=true"
              className="cta-button"
            >
              Book Your Session
            </Link>
          </div>
        </nav>
      </div>

      {/* Desktop Header */}
      <div className="nav-container nav_container_desktop">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>
        <nav>
          <ul className={`nav-menu${isServicePage ? " nav-menu--shopify" : ""}`}>
            <li>
              <NavLink
                to="/"
                end
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Home
              </NavLink>
            </li>
            {isServicePage ? (
              <>
                {navItems.map((item) => (
                  <li key={item.id}>
                    <span
                      className="shopify-nav-link"
                      onClick={() => scrollToSection(item)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.label}
                    </span>
                  </li>
                ))}
              </>
            ) : (
              <>
                <li>
                  <NavLink
                    to="/about"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/case-story"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Case Story
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/blogs"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Blog
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/contact"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Contact
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </nav>
        <div className={`nav-socials-button-wrapper${isServicePage ? " nav-socials--compact" : ""}`}>
          {!isServicePage && (
            <div className="nav-social-icons">
              <Link
                to="https://www.facebook.com/profile.php?id=61578997427316"
                className="nav-social-icon nav-social-icon--facebook"
                target="_blank"
              >
                <FiFacebook size={18} className="blog-social-icon" />
              </Link>
              <Link
                to="https://www.linkedin.com/company/techtcl/"
                className="nav-social-icon nav-social-icon--linkedin"
                target="_blank"
              >
                <FaLinkedinIn size={18} className="blog-social-icon" />
              </Link>
            </div>
          )}

          {!isServicePage && <div className="nav-divider" />}

          <div className="nav-cta-button">
            <HashLink
              smooth
              to="https://wa.link/tlqp49"
              target="_blank"
              className="cta-button btn-dot-glow"
            >
              <span className="live-dot"></span>
              Chat With Expert
            </HashLink>
          </div>
        </div>

        {/* <HashLink smooth to="/#booking" className="btn-primary">
          Book Now
          <FaArrowRight size={20} />
        </HashLink> */}
      </div>
    </header>
  );
}
